function a(r) {
  return r.fromArray(r.toArray().map((t) => Math.abs(t)));
}
export {
  a as AbsVector
};
//# sourceMappingURL=index.js.map
